/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';

const TaskDescription = {
  TASK_ASSIGNED: (_n?: Notification) => 'A new Task is assigned to you.',
  TASK_REMOVED_ASSIGNED: (_n?: Notification) =>
    'A Task has been unassigned from you.',
  TASK_UPDATED: (_n?: Notification) =>
    'A Task assigned to you has been updated.',
  TASK_NOTIFY: (_n?: Notification) =>
    'Heads up! Your task is due tomorrow. Make sure to complete it on time!',
  TASK_OVERDUE: (_n?: Notification) =>
    'Heads up! Your task  is now overdue. Please take action as soon as possible.',
};

const TaskLogs = {
  TASK_ASSIGNED: {
    title: 'Task Assigned',
    description: (_n?: Notification) => TaskDescription.TASK_ASSIGNED(_n),
    element: ({ actor, meta, referenceId }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account')
          return `/sales/tasks?keyword=${meta?.title}`;

        // eslint-disable-next-line max-len
        return `/preview/accounts/${accountId}/users/${accountUserId}/sales/tasks/${referenceId}?keyword=${meta?.title}`;
      }, [meta, actor, accountId, accountUserId, referenceId]);

      const task = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {TaskDescription['TASK_ASSIGNED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Task Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={task}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  TASK_REMOVED_ASSIGNED: {
    title: 'Task Assigned Removed',
    description: (_n?: Notification) =>
      TaskDescription.TASK_REMOVED_ASSIGNED(_n),
    element: ({ referenceId, meta, actor }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/sales/tasks/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/sales/tasks/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const task = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {TaskDescription['TASK_REMOVED_ASSIGNED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Task Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={task}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  TASK_UPDATED: {
    title: 'Task Updated',
    description: (_n?: Notification) => TaskDescription.TASK_UPDATED(_n),
    element: ({ referenceId, meta, actor }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/sales/tasks/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/sales/tasks/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const task = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {TaskDescription['TASK_UPDATED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Task Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={task}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  TASK_NOTIFY: {
    title: 'Task Notification',
    description: (_n?: Notification) => TaskDescription.TASK_NOTIFY(_n),
    element: ({ referenceId, meta, actor }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/sales/tasks/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/sales/tasks/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const task = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {TaskDescription['TASK_NOTIFY']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Task Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={task}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  TASK_OVERDUE: {
    title: 'Task Overdue',
    description: (_n?: Notification) => TaskDescription.TASK_OVERDUE(_n),
    element: ({ referenceId, meta, actor }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/sales/tasks/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/sales/tasks/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const task = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {TaskDescription['TASK_OVERDUE']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Task Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={task}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
};

export default TaskLogs;
